<template>
    <aside class="overflow-y-scroll" :class="{'open border-start':isOpen,'closed':!isOpen}">
        <PageEditorSectionPanel v-if="activeSectionId" :key="activeSectionId"/>
        <PageEditorContentAreaPanel v-else-if="activeContentAreaName"/>
        <PageEditorContentPanel v-else-if="activePageContentId" :key="activePageContentId"/>
        <PageEditorPagePanel v-else :key="pageId"/>
    </aside>
</template>

<script>
import PageEditorContentPanel from "./PageEditorContentPanel.vue"
import PageEditorContentAreaPanel from "./PageEditorContentAreaPanel.vue"
import PageEditorPagePanel from "./PageEditorPagePanel.vue"
import PageEditorSectionPanel from "./PageEditorSectionPanel.vue"

export default {
    name: "PageEditorRightSidebar",
    components: {
        PageEditorSectionPanel,
        PageEditorPagePanel,
        PageEditorContentAreaPanel,
        PageEditorContentPanel
    },
    computed: {
        pageEditor() {
            return this.$store.state.pageEditor
        },
        pageId() {
            return this.pageEditor.pageId
        },
        activeSectionId() {
            return this.pageEditor.activeSectionId
        },
        activeContentAreaName() {
            return this.pageEditor.activeContentAreaName
        },
        activePageContentId() {
            return this.pageEditor.activePageContentId
        },
        pagePanelActiveTab() {
            return this.pageEditor.pagePanelActiveTab
        },
        contentPanelActiveTab() {
            return this.pageEditor.contentPanelActiveTab
        },
        isOpen() {
            if (this.activeContentAreaName) {
                return true
            } else if (this.activePageContentId) {
                return !!this.contentPanelActiveTab
            } else {
                return !!this.pagePanelActiveTab
            }
        }
    }
}
</script>

<style scoped>
.closed {
    flex: 0 0 32px
}

.open {
    flex: 0 0 260px
}
</style>